// src/utils/SafeSvg.tsx
import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import parse, { HTMLReactParserOptions, domToReact } from 'html-react-parser';

type SafeSvgProps = { svg: string; className?: string };

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    // Eliminar cualquier <script> por si DOMPurify se configurara mal
    if (domNode.type === 'script') return null;
    // Eliminar atributos on* que pudieran sobrevivir
    if ('attribs' in domNode) {
      Object.keys(domNode.attribs).forEach((attr) => {
        if (/^on/i.test(attr)) delete domNode.attribs[attr];
      });
    }
    return undefined; // conservar nodo
  },
};

const SafeSvg: React.FC<SafeSvgProps> = ({ svg, className }) => {
  const parsedSvg = useMemo(() => {
    const clean = DOMPurify.sanitize(svg, {
      USE_PROFILES: { svg: true },
      ADD_ATTR: ['stroke-width', 'stroke-linecap', 'stroke-linejoin'],
    });

    // Convierto el string a elementos React
    return parse(clean, options);
  }, [svg]);

  return (
    <span className={className} role="img" aria-hidden="true">
      {parsedSvg}
    </span>
  );
};

export default SafeSvg;
